const TASK_TYPES = [
  'onboarding',
  'offboarding',
  'training',
  'document',
  'reviewee',
  'survey',
  'offer'
];

export default TASK_TYPES;
